import React, {Component} from "react"

import {SignupForm} from "~/components/"

class SignupView extends Component {
  render() {
    return (
      <div>
        <SignupForm />
      </div>
    )
  }
}

export default SignupView



// WEBPACK FOOTER //
// ./src/views/SignupView.js